export default {
  copyAddress: "Address copied.",
  copy: "Copied",
  operationsPageDetails: [
    { to: "deposit", tooltip: "Deposit" },
    { to: "withdrawal", tooltip: "Withdrawal" },
    { to: "exchange", tooltip: "Exchange" },
    { to: "transfer", tooltip: "Transfer" }
  ],
  deposit: {
    to: "deposit",
    title: "Deposit",
    historyOfDeposit: "Deposit History",
    userNotVerify: {
      title: "You are not verified",
      description: "Complete your verification to deposit Rial",
      button: "Complete Verification"
    },
    category: {
      crypto: {
        networkType: "Network Type",
        networkTypeNotice: `The network type specifies which network the transfer should be made on. To complete the transaction successfully, the same network must be selected on both the source and destination.`,
        address: "Network Address {address}",
        memo: "{memo} Address",
        warningText:
          "To deposit {name_locale} to your address, make sure to use both the address and {extra_name} {name_locale}.",
        noAddress: "Depositing this cryptocurrency is currently not possible.",
        hintTitle: "Only deposit {iso} to this address.",
        hintDescription:
          "Sending currencies other than {iso} to this address may result in their loss.",
        networkRequestBtn: "Request Network Address",
        warningTitle: "Warning",
        warningText1:
          "To deposit this currency, make sure to use both the address and memo simultaneously.",
        warningText2: "Otherwise, your assets will be lost.",
        acceptTermsText: "I have read and accepted the above terms",
        confirmBtn: "Confirm",
        copyAddress: "Address copied."
      },
      rial: {
        paymentMethod: "Deposit Method",
        paymentType: [
          { id: 0, field: "online_payment", route: "online", name: "Online" },
          {
            id: 5,
            field: "online_payment",
            route: "cart",
            name: "Card to card"
          },
          {
            id: 2,
            field: "offline_payment_with_identifier",
            route: "paymentID",
            name: "Deposit with Identifier"
          },
          {
            id: 1,
            field: "offline_payment",
            route: "offline",
            name: "Offline"
          },
          // {
          //   id: 4,
          //   field: "offline_payment",
          //   route: "cartToCart",
          //   name: "Offline card to card"
          // },
          {
            id: 3,
            field: "direct_payment",
            route: "direct-debit",
            name: "Dircet Debit"
          }
        ],
        directDebit: {
          maxWithdrawText: "Daily Limit: {amount} Rials",
          usageText: "Amount Used: {amount} Rials",
          expireText: "Contract Expiry Date: {amount}",
          newAccountBtn: "Add New Account",
          immediateChargeBtn: "Immediate Charge",
          doNotHaveImmediateAccText:
            "You have not activated an account for immediate charge yet.",
          shaparakRule:
            "According to Shaparak's new rules, the total daily payment through bank gateways cannot exceed {amount} Rials. For higher amounts, you can easily use the deposit with identifier or offline payment methods.",
          activateImmediateChargeBtn: "Activate Immediate Charge",
          removeImmediateChargeText: "Remove Immediate Charge",
          cancelBtn: "Cancel",
          acceptRemovingBtn: "Confirm Removal",
          copy: "Copied.",
          chooseBank: {
            maxWithdrawText: "Daily Limit: {amount} Rials",
            continueBtn: "Continue",
            cancelBtn: "Cancel"
          },
          createContractForm: {
            activateWithdrawText: "Activate direct withdrawal from",
            maxAmountTrx: "Maximum transaction limit",
            contractPreiod: "Contract period",
            cancelBtn: "Cancel",
            addContractBtn: "Create Contract",
            successDeposit: "Your Rial deposit was successful.",
            bankName: "Bank Name",
            depositAmount: "Deposit Amount",
            trxNumber: "Transaction Number",
            dateTitle: "Date and Time",
            walletBtn: "Wallet",
            unSuccessfullTrxText: "Unsuccessful Transaction",
            maxDailyRemainedText: "Remaining daily limit",
            immediateChargeBtn: "Immediate Charge"
          },
          directDebitTable: {
            immediateChargeHistoryTitle: "Immediate Charge History"
          }
        },
        offline: {
          accountListTitle: "View Excoino Account Numbers",
          notice: {
            title: "Please Note",
            description:
              "For offline Rial deposits, make sure to follow the instructions below; otherwise, your transaction will be suspended.",
            firstRule: "1) The bank card or account must be in your name.",
            secondRule:
              '2) When making PAAYE and SATNA payments, be sure to write the phrase "Tadeiyeh Deeyoon" in the payment description.',
            thirdRule:
              "3) The deposit identifier is your national ID number. Make sure to write it on the bank receipt when making a deposit at the bank.",
            badgeText:
              'For Bank Shahr deposits, in addition to writing the deposit identifier, make sure to write the number "90" in the reference code section when visiting the bank in person or using the Bank Shahr app.'
          },
          form: {
            title: "Register Offline Deposit Information",
            amountInputLabel: "Deposit Amount",
            amountInputValidation: "Enter the deposit amount.",
            depositType: "Deposit Type",
            selectLabel:
              "To which account did you deposit? | To which card did you deposit?",
            noResult: "No results found.",
            selectValidation:
              "Select the bank account. | Select the bank card.",
            bankInputLabel: "Source Bank",
            bankInputValidation: "Enter the source bank.",
            trackingInputLabel: "Tracking Code",
            trackingInputValidation: "Enter the tracking code.",
            dateInputLabel: "Deposit Date",
            dateInputValidation: "Select the deposit date.",
            imageInputLabel: "Bank receipt Image",
            imageInputValidation: "Upload the bank receipt.",
            button: "Submit"
          },
          offlineTable: {
            title: "Offline Rial Deposit History",
            tableHeader: {
              paymentDate: "Payment Date",
              amount: "Deposit Amount (Rials)",
              action: "Action",
              bankName: "Bank Name",
              referBankCode: "Bank Reference Number",
              providerReferCode: "Provider Reference Number",
              status: "Status"
            }
          },
          accountList: {
            accountOwner: "Account Owner Name",
            accountNumber: "Account Number",
            depositId: "Deposit Identifier",
            cardNumber: "Card Number",
            copyAccount: "Account number was copied.",
            copyDeposit: "Deposit number was copied"
          }
        },
        online: {
          warningDescription:
            "According to Shaparak's regulations, please note that the maximum daily total of amounts paid through bank gateways is 250,000,000 Rials. If you need to deposit larger amounts, you can easily use the deposit with identifier feature. This method not only speeds up the deposit process but also provides faster credit increase compared to offline methods.",
          warningLink: "Deposit with Identifier",
          availableBalance: "Your current balance",
          amount: "Deposit Amount",
          creditPortal: "Through the credit portal",
          bankPortal: "Through the web portal",
          button: "Continue Deposit Process",
          minBalanceError: "The minimum allowed amount is {min}.",
          maxBalanceError: "",
          maximumText: "Maximum",
          canNotBeLessAmount: "The amount cannot be less than {amount} Rials",
          canNotBeMoreAmount: "The amount cannot be more than {amount} Rials",
          cardSelectionPlaceholder: "Select Bank Card",
          addCard: "Add Card",
          addNewCard: "Add New Bank Card",
          feeInfo:
            "Due to the fees of some gateways, the amount you pay may be slightly more than the entered amount. Please note that Excoino does not receive any share of this fee."
        },
        paymentId: {
          checkDepositId: `
          <ul>
          <p>Please make sure to consider the following two points before making any deposit to Excoino:</p>
          <li>1.Double-check the IBAN number carefully. (The IBAN may be different for each deposit)</li>
          <li>2.Your national ID number is your deposit reference. Be sure to enter your national ID in the "Reference Number" field when making a deposit.</li>
          <li>3.Using an incorrect reference number or IBAN may result in a failed or delayed deposit.</li>
          <li>4.If the deposit is made from a bank affiliated with Excoino, the account will be credited more quickly due to internal processing.</li>
          </ul>`,
          watchGuideVideo: "Watch Guide Video",
          close: "Close",
          receiveDepositId: "Get Deposit Identifier",
          depositId: "Deposit Identifier",
          requiredDepositId: "Registration upon deposit is mandatory.",
          depositNumber: "Deposit Number",
          depositSheba: "Deposit Sheba",
          requiredId: "",
          paymentIdTable: {
            depositHistoryTitle: "Deposit History with Identifier"
          },
          dialogText:
            "It is not possible to deposit via integrated cards and register them in the user account."
        }
      }
    }
  },
  withdraw: {
    to: "withdrawal",
    title: "Withdrawal",
    withdrawHistoryTitle: "Withdrawal History",
    otp: {
      title: {
        text1: "You have not activated",
        text2: "yet",
        text3: "One of the required values ​​is not verified"
      },
      description: {
        text1:
          "To enhance security during cryptocurrency withdrawal, you need to activate",
        text2: "from the account settings."
      }
    },
    category: {
      crypto: {
        networkType: "Network Type",
        networkTypeNotice: `The network type specifies which network the transfer should be made on. To complete the transaction successfully, the same network must be selected on both the source and destination.`,
        addressLabel: "Address",
        addNewAddress: "Add New Address",
        submitBtn: "Continue Withdrawal Process",
        inventory: "Withdrawable Balance",
        transferFee: "Transfer Fee",
        amountReceived: "Net Received Amount",
        warningText:
          "To withdraw {name_locale} to your address, make sure to use both the address and {extra_name} {name_locale} tag.",
        noAddress: "Withdrawing this cryptocurrency is currently not possible.",
        addressNotCorrect: "The entered address is incorrect.",
        mobileValidate: {
          title:
            "You need to register your mobile number for cryptocurrency withdrawal.",
          description:
            "To withdraw cryptocurrency, you need to register your mobile number. For enhanced security during cryptocurrency withdrawal, you need to verify your mobile number. Please go to the account settings and verify your mobile number, then proceed with the withdrawal process."
        },
        setting: "Account Settings",
        doNotNeedExtraName: "No need for {extraName}",
        addAddressCard: {
          addNewAddress: "Add New Address",
          selectNetwork: "Select Network",
          title: "Title",
          walletAddress: "Wallet Address",
          add: "Add"
        },
        cancelOrderCard: {
          areYouSure: "Are you sure you want to cancel?",
          waitFor2Min:
            "If you cancel, you will not be able to register a new address for 2 minutes.",
          sureCancel: "I'm sure, cancel",
          canecelation: "Cancel Cancellation"
        },
        deleteAddressCard: {
          deleteWalletAddress: "Delete Wallet Address",
          areYouSure: "Are you sure you want to delete this address?",
          sureDelete: "I'm sure, delete it",
          canecelation: "Cancel Deletion"
        },
        extraFeeCard: {
          increasedFee: "Your order fee has increased",
          continueOrder: "Got it, continue the order",
          cancel: "Cancel Order"
        },
        otpCard: {
          confirmCodeTitle: "Confirmation Code",
          enterCode:
            "To add an address, please enter the code sent to (<span class='font-Bold-14' >{phoneNumber}</span >).",
          receiveCodeAgain: "Resend Confirmation Code",
          continue: "Continue",
          remainTime: "Resend the code in {second} seconds"
        },
        sendMobileCard: {
          securityConfirm: "Security Confirmation",
          areYouSure: "Are you sure you want to delete this address?",
          mobileNumber: "Mobile Number",
          continue: "Continue"
        },
        tagCard: {
          useFrom: "Use {extraName}",
          useMemo:
            "For {typeOfTransaction} {name_locale}, make sure to use both the address and {extra_name} {name_locale}.",
          understood: "Got it"
        },
        steps: {
          step1: "Select Currency",
          step2: "Select Network"
        }
      },
      rial: {
        withdrawType: "Withdrawal Type",
        yourInventory: "Your Current Balance",
        withdrawLabel: "Withdrawal Amount",
        shebaLabel: "IBAN",
        cardNumberLabel: "Card Number",
        addShebaNumber: "Add New IBAN",
        addCardNumber: "Add New Card Number",
        shebaNumberHint: "Please select or add the desired IBAN",
        cardNumberHint: "Please select or add the desired card number",
        continueBtn: "Continue Withdrawal Process",
        cardToCardText:
          "Currently, withdrawal via card deposit is not possible.",
        authenticationTitle: "You are not verified",
        authenticationDescription:
          "Complete your verification to withdraw Rial",
        authenticationBtn: "Complete Verification",
        sendAgainBtn: "Resend Confirmation Code",
        receive: "You will receive",
        accountName: "Account Holder Name",
        transactionStatus: "View Transaction Status",
        submitTime: "Submission Date and Time",
        mobileCodeText: {
          text1:
            "To confirm the withdrawal request, please enter the code sent to (",
          text2: ")."
        },
        rulesText: {
          text1:
            "By placing this order, I confirm that I have read and accepted the",
          excoinoLink: "Excoino rules",
          text2: "."
        },
        toWithdrawLessThan: "To withdraw less than {amount} million Tomans",
        fee: "Fee: 50,000 Rials",
        defineShaba:
          "To facilitate and receive the amount faster for withdrawals over 100 million Tomans, register a different IBAN for each 100 million Tomans.",
        increaseFee:
          "A fee of {amount} Rials will be deducted for each transaction.",
        depositToSheba: "Deposit to IBAN",
        depositToCard: "Deposit to Card",
        depositToCardTitle:
          "Instant Card Deposit | For withdrawals less than 50 million Tomans",
        shebaNotCorrect: "The entered IBAN is incorrect.",
        steps: {
          step1: "Select Withdrawal Type",
          step2: "Select Withdrawal Amount"
        }
      }
    }
  },
  exchange: {
    submitOrder: {
      endTime: "Your time to complete this order has expired.",
      timeNotice: "Your time to complete this order",
      payment: "Payment",
      received: "Received",
      wage: "Conversion Fee",
      submit: "Confirm and Finalize",
      tryAgain: "Retry",
      successText: "Your order was successfully registered.",
      transactionNumber: "Transaction Number",
      cancel: "Back",
      goWallet: "Go to Wallet",
      goTransaction: "Go to Transactions",
      goToTransfer: "Transfer To Spot",
      changePrice: "Conversion Rate"
    },
    to: "exchange",
    title: "Exchange",
    inventory: "Balance",
    youPay: "You Pay",
    receive: "You Receive",
    youPayModalTitle: "Select Payment Currency",
    youPayModalPlaceholder: "Search by currency name or symbol...",
    receiveModalTitle: "Select Receiving Currency",
    receiveModalPlaceholder: "Search by currency name or symbol...",
    btn: {
      half: "Half",
      all: "All",
      min: "Minimum"
    },
    submit: "Place Order",
    symbol: "Symbol",
    property: "Asset",
    currenciesAutoComplete: {
      searchPlaceholder: "Search by currency name or symbol...",
      notFound: "No results found."
    },
    exchangeInput: {
      thereIsNoCoin: "No currency available",
      approximately: "about"
    },
    balanceNotEnough: "Your wallet balance is insufficient.",
    maxReceive: "The maximum amount receivable is {amount}.",
    minReceive: "The minimum amount receivable is {amount}."
  },
  transfer: {
    to: "transfer",
    title: "Transfer",
    transferHistoryTitle: "Transfer History",
    transferToMarket: "Transfer to Spot",
    acceptOrder: "",
    continueProcess: "Continue the Transfer Process",
    haveNotAcceptRules: "You have not accepted the Excoino Market rules yet",
    acceptRulesText:
      "Dear user, to use the Excoino Market, you must first accept the terms of this section. To do this, go to the Excoino Market section, read and accept the terms, and then return to this page to transfer cryptocurrency.",
    goToMarket: "Go to Excoino Market",
    balanceNotEnought: "Your wallet balance is insufficient.",
    maxTransfer: "The maximum transferable amount is {amount}.",
    minTransfer: "The minimum transferable amount is {amount}.",
    confirmOrder:
      'By placing this order, I confirm that I have read and accepted the <a href="{url}" target="_blank" class="font-Bold-12 gray1--text crypto-link">Excoino rules</a>.'
  },
  routeQueryTypes: [
    {
      query: "IRR",
      tooltip: "Rial"
    },
    {
      query: "cryptoCurrency",
      tooltip: "Cryptocurrency"
    }
  ],
  excoinoRulesFirstPart:
    "By performing this transaction, I confirm that I have read and accepted the",
  excoinoRulesLink: "Excoino rules",
  excoinoRulesSecondPart: ".",
  cartToCart: {
    title: "Registration of card-to-card deposit information online",
    cartNumberTitle: "Destination card number",
    hint: "Online card to card deposit history",
    tableHeader: "Online card to card deposit history"
  }
};
